import { ConvexReactClient } from "convex/react";

export function createConvexClient(url: string | undefined): ConvexReactClient {
  if (!url) {
    throw new Error(
      "VITE_CONVEX_URL is required. Copy .env.example to .env.local and configure the Convex deployment URL.",
    );
  }

  return new ConvexReactClient(url);
}
